"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnumFirstValue = exports.tryParseAsNumberArray = exports.tryParseAsDate = exports.tryParseDecimal = exports.tryParseAsBoolean = exports.tryParseAsNumber = exports.tryParseAsEnumArray = exports.tryParseAsEnum = void 0;
const validators_1 = require("./validators");
const tryParseAsEnum = (type, input) => {
    if ((0, validators_1.isNullOrEmpty)(input)) {
        return undefined;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const casted = input;
    return type[casted];
};
exports.tryParseAsEnum = tryParseAsEnum;
const tryParseAsEnumArray = (type, inputs) => {
    if (!inputs) {
        return undefined;
    }
    if (!Array.isArray(inputs)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const x = (0, exports.tryParseAsEnum)(type, inputs.toString());
        if (x)
            return [x];
        return undefined;
    }
    const result = inputs?.map((input) => {
        const enumVal = (0, exports.tryParseAsEnum)(type, input);
        return enumVal !== undefined ? enumVal : type[''];
    });
    return result;
};
exports.tryParseAsEnumArray = tryParseAsEnumArray;
const tryParseAsNumber = (input, signedNumber = false) => {
    if (!input && input !== 0) {
        return undefined;
    }
    const numberVal = Number(input);
    if (Number.isNaN(numberVal)) {
        return undefined;
    }
    if (!signedNumber && numberVal < 0) {
        return 0;
    }
    return numberVal;
};
exports.tryParseAsNumber = tryParseAsNumber;
const tryParseAsBoolean = (input) => {
    if (input === true)
        return true;
    if (input === false)
        return false;
    if (!input)
        return undefined;
    if (input === 'true')
        return true;
    if (input === 'false')
        return false;
    return undefined;
};
exports.tryParseAsBoolean = tryParseAsBoolean;
const tryParseDecimal = (value) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return value !== 0 && !value ? null : parseFloat(value.toString());
};
exports.tryParseDecimal = tryParseDecimal;
const tryParseAsDate = (input) => {
    if (!input) {
        return undefined;
    }
    const parseResult = Date.parse(input);
    if (Number.isNaN(parseResult)) {
        return undefined;
    }
    return new Date(parseResult);
};
exports.tryParseAsDate = tryParseAsDate;
const tryParseAsNumberArray = (inputs) => {
    if (!inputs) {
        return undefined;
    }
    if (!Array.isArray(inputs)) {
        const x = (0, exports.tryParseAsNumber)(inputs);
        if (x)
            return [x];
        return undefined;
    }
    const result = inputs?.map((input) => {
        const number = (0, exports.tryParseAsNumber)(input);
        return number !== undefined ? number : 0;
    });
    return result;
};
exports.tryParseAsNumberArray = tryParseAsNumberArray;
const getEnumFirstValue = (enumVariable) => {
    const enumValues = Object.values(enumVariable);
    return enumValues[0];
};
exports.getEnumFirstValue = getEnumFirstValue;
